<template lang="pug">
.sancoes-admin-table
    grid-table-component(
        :headers='headersSancoesAdministrativas',
        :data='sancoesAdministrativas',
        :is-paginated='false'
    )
        template(v-slot:orgaoAutuacao='{ item }')
            span {{ item.orgaoAutuacao === 'ESTADUAL' ? 'Estadual' : 'Federal' }}

        template(v-slot:dataAutuacao='{ item }')
            span {{ item.dataAutuacao | data }}

        template(v-slot:acao='{ item }')
            dropdown-component(
                :list='acao'
                @input="onAction($event, item)"
                :is-select='false'
                position='left'
            )

        template(v-slot:validacao='{ item }')
            validacao-component(
                :tipo='item.tipo',
                :item='item',
                :tipos-documentos='tiposDocumentos',
            )
    modal-component(
        v-if='exibirModalAuto',
        title='Sanções Administrativas',
        @close='exibirModalAuto = false'
    )
        ModalVisualizarSancoes(:autoInfracao='itemSelecionado')

    modal-component(
        v-if='exibirModalDocumentos',
        title='Documentos',
        @close='exibirModalDocumentos = false'
    )
        AnaliseModalDocumentos(:etapa='itemSelecionado')

    modal-component(
        v-if='exibirModalMapa',
        :title="`Imóvel: ${codigoImovel} - Auto: (${itemSelecionado?.numeroAutoInfracao})`",
        @close='exibirModalMapa = false',
        width='900px'
    )
        .modal-content
            Mapa(
                ref='mapa'
                :area='areaMapa'
                :codigoImovel='codigoImovel'
                @loaded='desenharPoligonos'
            )
            table
                thead
                    tr
                        th
                        th
                tbody
                    tr
                        td.titulo-arquivo-foto
                            b Arquivo vetorial
                        td.descricao-foto
                            | {{ nomeAreaGeometria }} KML
                            button(
                                type="button"
                                class="botao-acoes"
                                title="Baixar arquivo KML"
                                @click="baixarArquivoKML"
                            )
                                i(class="el-icon-download")
            BotaoComponent(
                style="display: flex; justify-content: flex-end; margin-top: 15px;"
                :tipo="'limpar'"
                :titulo="'Fechar'"
                icone='el-icon-close'
                :acao="() => exibirModalMapa = false"
            )
</template>

<script>
import ValidacaoComponent from '@/views/analise/components/ValidacaoComponent.vue';
import AnaliseModalDocumentos from '@/views/analise/components/AnaliseModalDocumentos.vue';
import ModalVisualizarSancoes from '@/views/analise/components/etapaMRA/ModalVisualizarSancoes.vue';
import { obterGeometrias } from '@/services/etapa-geometria.service';
import Mapa from '@/components/Mapa/Mapa.vue';
import BotaoComponent from '@/components/design/BotaoComponent.vue';
import FileSaver from 'file-saver';

export default {

    name: 'MraSancoesAdmTable',

    components: {
        ValidacaoComponent,
        AnaliseModalDocumentos,
        ModalVisualizarSancoes,
        Mapa,
        BotaoComponent
    },

    props: {
        sancoesAdministrativas: {
            type: Array,
        },

        tiposDocumentos: {
            type: Array,
            required: true,
        },
        codigoImovelCriptografado: {
            type: String,
            required: true,
        },
        codigoImovel: {
            type: String,
            default: null,
        },
        aderiuPra: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            headersSancoesAdministrativas: [
                { text: 'Auto de infração', field: 'numeroAutoInfracao' },
                { text: 'Órgão responsável', field: 'orgaoAutuacao' },
                { text: 'Descrição', field: 'descricao' },
                { text: 'Data da infração', field: 'dataAutuacao' },
                { text: 'Ação', field: 'acao' },
                { text: 'Avaliação', field: 'validacao' },
            ],
            acao: [
                {
                    id: 'VISUALIZAR',
                    label: 'Visualizar',
                    icon: 'mdi-magnify'
                },
                { id: 'DOC', label: 'Documentos', icon: 'mdi-text-box-search-outline' },
                { id: 'MAP', label: 'Visualizar Mapa', icon: 'mdi-map' },
            ],
            itemSelecionado: null,
            exibirModalDocumentos: false,
            exibirModalAuto: false,
            exibirModalMapa: false,
            geometrias: [],
            urlSicar: process.env.VUE_APP_SICAR_URL,
            token: null,
            nomeAreaGeometria: 'Localização do Embargo',
            areaMapa: 'APP'
        };

    },

    mounted() {
        if (this.aderiuPra) {
            this.token = process.env.VUE_APP_TOKEN_MAPA_SICAR_COM_PRA;
        } else {
            this.token = process.env.VUE_APP_TOKEN_MAPA_SICAR_SEM_PRA;
        }
    },
    methods: {
        onAction(event, item) {
            if (event.id === 'DOC') {
                this.itemSelecionado = item;
                this.exibirModalDocumentos = true;
            }
            if (event.id === 'VISUALIZAR') {
                this.itemSelecionado = item;
                this.exibirModalAuto = true;
            }
            if (event.id === 'MAP') {
                this.buscarGeometria(item);
            }
        },
        async buscarGeometria(item) {
            this.itemSelecionado = item;

            if (item.geometrias && item.geometrias.length > 0) {
                const geometriaIds = item.geometrias.map(geo => geo.id);
                try {
                    this.geometrias = await obterGeometrias(geometriaIds);
                } catch (error) {
                    console.error('Erro ao obter geometrias:', error);
                    this.$toast({
                        showClose: true,
                        message: 'Erro ao buscar geometrias da sanção.',
                        type: 'error'
                    });
                    return;
                }
            } else {
                console.warn('Item não possui geometrias associadas');
                this.geometrias = [];
            }

            this.nomeAreaGeometria = `Localização do Embargo - ${item.numeroAutoInfracao || ''}`;

            if (!this.codigoImovel) {
                console.error('Código do imóvel não disponível. Prop recebida:', this.codigoImovel);
                this.$toast({
                    showClose: true,
                    message: 'Código do imóvel não disponível. Não é possível exibir o mapa.',
                    type: 'error'
                });
                return;
            }
            this.exibirModalMapa = true;
        },
        desenharPoligonos() {
            if (!this.geometrias || this.geometrias.length === 0) {
                console.warn('Nenhuma geometria disponível para desenhar');
                return;
            }

            if (!this.$refs.mapa) {
                console.error('Referência do mapa não disponível');
                return;
            }

            this.geometrias.forEach((geometria, index) => {
                let coordenadas = null;
                let tipoGeometria = null;

                if (geometria && typeof geometria === 'object') {
                    if (geometria.type && geometria.coordinates) {
                        tipoGeometria = geometria.type;
                        coordenadas = geometria.coordinates;
                    } else if (geometria.coordinates) {
                        coordenadas = geometria.coordinates;
                    }
                } else if (Array.isArray(geometria)) {
                    coordenadas = geometria;
                }

                if (!coordenadas) {
                    console.error('Geometria inválida - formato não reconhecido:', geometria);
                    return;
                }

                let coordenadasPoligono = null;

                if (tipoGeometria === 'Polygon') {
                    coordenadasPoligono = Array.isArray(coordenadas[0]) ? coordenadas[0] : coordenadas;
                } else if (tipoGeometria === 'MultiPolygon') {
                    coordenadasPoligono = Array.isArray(coordenadas[0]) && Array.isArray(coordenadas[0][0])
                        ? coordenadas[0][0]
                        : (Array.isArray(coordenadas[0]) ? coordenadas[0] : coordenadas);
                } else if (Array.isArray(coordenadas)) {
                    if (Array.isArray(coordenadas[0])) {
                        if (Array.isArray(coordenadas[0][0])) {
                            coordenadasPoligono = coordenadas[0];
                        } else {
                            coordenadasPoligono = coordenadas;
                        }
                    } else {
                        console.error('Formato de coordenadas não suportado:', coordenadas);
                        return;
                    }
                } else {
                    console.error('Formato de coordenadas não suportado:', coordenadas);
                    return;
                }

                const coordenadasValidadas = this.validarCoordenadasPolygon(coordenadasPoligono);

                if (!coordenadasValidadas || coordenadasValidadas.length < 3) {
                    console.error('Coordenadas do polígono inválidas:', coordenadasPoligono);
                    return;
                }

                const coordenadasParaMapa = coordenadasValidadas;

                const latLngs = coordenadasValidadas.map((coord) => [coord[1], coord[0]]);
                const centro = this.calcularCentro(latLngs);

                this.$refs.mapa.desenharPoligonoFixado(coordenadasParaMapa, centro);
            });

            this.$nextTick(() => {
                const mapaLeaflet = this.$refs.mapa.map;

                if (mapaLeaflet) {
                    const zoomAtual = mapaLeaflet.getZoom();
                    mapaLeaflet.setZoom(zoomAtual + 1);
                }
            });

            this.$nextTick(() => {
                const instanciaMapa = this.$refs.mapa.map;
                if (instanciaMapa) {
                    instanciaMapa.eachLayer((layer) => {
                        if (layer instanceof L.Marker || (layer.options && layer.options.icon)) {
                            instanciaMapa.removeLayer(layer);
                        }
                    });
                }
            });

        },
        validarCoordenadasPolygon(coordenadas) {
            if (Array.isArray(coordenadas) && coordenadas.length > 0) {
                const coordenadasValidas = coordenadas
                    .map((coord) => {
                        if (Array.isArray(coord) && coord.length === 2 && !isNaN(coord[0]) && !isNaN(coord[1])) {
                            return coord;
                        } else {
                            console.error('Coordenada inválida:', coord);
                            return null;
                        }
                    })
                    .filter((coord) => coord !== null);

                return coordenadasValidas.length === coordenadas.length ? coordenadasValidas : null;
            }
            return null;
        },
        calcularCentro(latLngs) {
            let somaLat = 0;
            let somaLng = 0;
            latLngs.forEach((coord) => {
                somaLat += coord[0];
                somaLng += coord[1];
            });
            return [somaLat / latLngs.length, somaLng / latLngs.length];
        },
        baixarArquivoKML() {
            if (!this.geometrias || this.geometrias.length === 0) {
                this.$toast({
                    showClose: true,
                    message: 'Não há geometria disponível para download.',
                    type: 'warning'
                });
                return;
            }

            try {
                const kmlContent = this.converterGeoJSONParaKML(this.geometrias);
                const blob = new Blob([kmlContent], { type: 'application/vnd.google-earth.kml+xml' });
                const filename = `${this.nomeAreaGeometria.replace(/[^a-zA-Z0-9]/g, '_')}.kml`;
                FileSaver.saveAs(blob, filename);
            } catch (error) {
                console.error('Erro ao gerar arquivo KML:', error);
                this.$toast({
                    showClose: true,
                    message: 'Erro ao gerar arquivo KML.',
                    type: 'error'
                });
            }
        },
        converterGeoJSONParaKML(geometrias) {
            let kml = '<?xml version="1.0" encoding="UTF-8"?>\n';
            kml += '<kml xmlns="http://www.opengis.net/kml/2.2">\n';
            kml += '<Document>\n';
            kml += `<name>${this.nomeAreaGeometria}</name>\n`;

            geometrias.forEach((geometria, index) => {
                if (!geometria) {
                    return;
                }

                let tipoGeometria = geometria.type;
                let coordenadas = geometria.coordinates;

                if (!tipoGeometria || !coordenadas) {
                    console.warn(`Geometria ${index + 1} inválida:`, geometria);
                    return;
                }

                if (tipoGeometria === 'Polygon') {
                    const anelExterno = coordenadas[0];
                    if (anelExterno && Array.isArray(anelExterno) && anelExterno.length > 0) {
                        let coordinatesStr = '';
                        anelExterno.forEach((coord) => {
                            if (Array.isArray(coord) && coord.length >= 2) {
                                coordinatesStr += `${coord[0]},${coord[1]},0 `;
                            }
                        });
                        if (anelExterno.length > 0 && anelExterno[0] && anelExterno[anelExterno.length - 1]) {
                            const primeiro = anelExterno[0];
                            const ultimo = anelExterno[anelExterno.length - 1];
                            if (primeiro[0] !== ultimo[0] || primeiro[1] !== ultimo[1]) {
                                coordinatesStr += `${primeiro[0]},${primeiro[1]},0 `;
                            }
                        }

                        kml += '<Placemark>\n';
                        kml += `<name>Geometria ${index + 1}</name>\n`;
                        kml += '<Polygon>\n';
                        kml += '<outerBoundaryIs>\n';
                        kml += '<LinearRing>\n';
                        kml += `<coordinates>${coordinatesStr.trim()}</coordinates>\n`;
                        kml += '</LinearRing>\n';
                        kml += '</outerBoundaryIs>\n';
                        kml += '</Polygon>\n';
                        kml += '</Placemark>\n';
                    }
                } else if (tipoGeometria === 'MultiPolygon') {
                    coordenadas.forEach((poligono, polyIndex) => {
                        if (poligono && Array.isArray(poligono) && poligono.length > 0) {
                            const anelExterno = poligono[0];

                            if (anelExterno && Array.isArray(anelExterno) && anelExterno.length > 0) {
                                let coordinatesStr = '';
                                anelExterno.forEach((coord) => {
                                    if (Array.isArray(coord) && coord.length >= 2) {
                                        coordinatesStr += `${coord[0]},${coord[1]},0 `;
                                    }
                                });

                                if (anelExterno.length > 0 && anelExterno[0] && anelExterno[anelExterno.length - 1]) {
                                    const primeiro = anelExterno[0];
                                    const ultimo = anelExterno[anelExterno.length - 1];
                                    if (primeiro[0] !== ultimo[0] || primeiro[1] !== ultimo[1]) {
                                        coordinatesStr += `${primeiro[0]},${primeiro[1]},0 `;
                                    }
                                }

                                kml += '<Placemark>\n';
                                kml += `<name>Geometria ${index + 1} - Polígono ${polyIndex + 1}</name>\n`;
                                kml += '<Polygon>\n';
                                kml += '<outerBoundaryIs>\n';
                                kml += '<LinearRing>\n';
                                kml += `<coordinates>${coordinatesStr.trim()}</coordinates>\n`;
                                kml += '</LinearRing>\n';
                                kml += '</outerBoundaryIs>\n';
                                kml += '</Polygon>\n';
                                kml += '</Placemark>\n';
                            }
                        }
                    });
                } else {
                    console.warn(`Tipo de geometria não suportado: ${tipoGeometria}`);
                }
            });

            kml += '</Document>\n';
            kml += '</kml>';

            return kml;
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    padding: 15px;
}

table {
    width: 100%;
    margin-top: 15px;
    border-collapse: collapse;
}

table thead tr th {
    text-align: left;
    padding: 8px;
    border-bottom: 1px solid #ddd;
}

table tbody tr td {
    padding: 8px;
    border-bottom: 1px solid #ddd;
}

.titulo-arquivo-foto {
    font-weight: bold;
    width: 150px;
}

.descricao-foto {
    display: flex;
    align-items: center;
    gap: 10px;
}

.botao-acoes {
    background: none;
    border: none;
    cursor: pointer;
    color: #409EFF;
    font-size: 16px;
    padding: 5px;
}

.botao-acoes:hover {
    color: #66b1ff;
}
</style>
